export default "__VITE_ASSET__DcBrS6HV__"